/** @file docEntryOf: the document's facet entry a Tile address names (what `facet.setEntry` would edit). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';
import type { EditorStore, TileRef } from '../../state/editorTypes';

/** Entry `ref.entry` of impostor `ref.drawable` in the open document, or null (no document, not an impostor, no entry). */
export function docEntryOf(store: EditorStore, ref: Pick<TileRef, 'drawable' | 'entry'>): FacetEntry | null {
  const d = store.getState().puppet.doc?.puppet.drawables.find((x) => x.id === ref.drawable);
  return d?.kind === 'impostor' ? (d.facets[ref.entry] ?? null) : null;
}
